<template>
	<div class="container">
		<el-page-header @back="goBack" content="修改">
		</el-page-header>
		<div class="cont-body" v-loading="searchLoading">
			<div class="content hundvh">
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">面向地区<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-cascader
						    v-model="areaId"
							:props="cascaderprops"
						    :options="citysList"
						    @change="handleCityChange">
						</el-cascader>
					</div>
				</div>
				<div class="ctx-item inlinediv">
					<div class="ctx-item-t">
						<div class="ctx-item-head">店面名称<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入店面名称" v-model="shopName" maxlength="30"/>
					</div>
				</div>
				<div class="ctx-item inlinediv">
					<div class="ctx-item-t">
						<div class="ctx-item-head">店面地点<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入店面地点" v-model="shopAddr" maxlength="30"/>
					</div>
				</div>
				<div class="ctx-item inlinediv">
					<div class="ctx-item-t">
						<div class="ctx-item-head">商品名<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入商品名(包含品牌)" v-model="proName" maxlength="30"/>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">商品描述<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-input type="textarea" v-model="proDesc" :autosize="{ minRows: 4}" maxlength="200" placeholder="请输入商品描述" show-word-limit></el-input>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">价格<label v-if="CurrencySymbol.length > 0">({{CurrencySymbol}})</label><label class="bishu">*</label></div>
						<div class="pub_coin_unit_desc">面向地区所在国家币种</div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入价格" v-model="proPrice" maxlength="8" type="digit"/>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">折扣日期<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-date-picker
							v-model="discountStartDate"
							type="date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							placeholder="选择折扣开始日期">
						</el-date-picker>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head"></div>
					</div>
					<div class="ctx-item-b" >
						<el-date-picker
							v-model="discountEndDate"
							type="date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							placeholder="选择折扣结束日期">
						</el-date-picker>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">送货方式<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-radio-group v-model="deliveryModel" class="radio_warp">
							<div v-for="(item,index) in deliveryModelList" :key="item.key" class="radio_itm_warp">
								<el-radio :label="item.key">{{item.value}}</el-radio>
							</div>
						</el-radio-group>
					</div>
				</div>
				<div class="ctx-item inlinediv">
					<pickContact ref="pickContact" :queryUid="userInfo.fayanboId" :baseUrlpath="baseUrlpath" @changeConcactShow="changeConcactShow" :isShowConcact="isShowConcact" :isDetail="isDetail"></pickContact>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">物品照片<label class="bishu">*</label></div>
						<div class="ctx-item-headdesc">（尽可能全面，清晰）</div>
						<div class="ctx-item-headdesc"><label>({{finalFileList.length}}/{{limitFilesNum}})</label></div>
					</div>
					<div class="ctx-item-b">
						<uploadFile v-if="hasSearch" :baseUrlpath="baseUrlpath" :fileList="fileList" @addOrMulitiFileList="addOrMulitiFileList"></uploadFile>
					</div>
				</div>
				<div class="btn-foot">
					<div class="btn" @click="publish()">修改</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapActions} from 'vuex'
	import uploadFile from '@/components/upload/uploadFile.vue'
	import pickContact from '@/components/pickContact.vue'
	import {queryUrl,doPost,commitFileUrl,queryUrlWithUInfo,postWithUInfo} from '@/api/index';
	import { Toast } from 'mint-ui';
	export default {
		components:{
		  uploadFile,pickContact
		},
		data(){
			return {
				cascaderprops:{
					value:'id',
					label:'name',
					children:'child'
				},
				CurrencySymbol:'',
				areaId:'',
				shopName:'',
				shopAddr:'',
				reqNail:'',
				proDesc:'',
				areaIndex:'',
				proName:'',
				deliveryModel:'0',
				deliveryModelList:[],
				discountEndDate:'',
				discountStartDate:'',
				proPrice:'',
				indicatorStyle: `height: 50px;`,
				maskStyle:``,
				fileList:[],
				finalFileList:[],
				limitFilesFlg:true,
				limitFilesNum:9,
				baseUrlpath:'',
				dqList:[],
				proTypeList:[],
				proTypeIndex:'',
				proTypeId:'',
				isShowConcact:false,
				hasSearch:false,
				searchLoading:false,
				isDetail:false,
				reqNo:'',
				sdr_userId:''
			}
		},
		created() {
			// console.log(this.$route.query)
			this.reqNo = this.$route.query.reqNo;
			this.reqType = this.$route.query.reqType;
			this.citysList = this.$util.citysList;
			this.proTypeList = this.$util.xzProTypeList;
			this.deliveryModelList = this.$util.deliveryModelList;
			this.initReqInfo();
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		methods:{
			changeConcactShow(val){
				this.isShowConcact = val
			},
			goBack() {
				this.$util.goBack();
			},
			async initReqInfo(){
				this.searchLoading = true
				const initres = await queryUrlWithUInfo('/apis/getReqInfo',{reqNo:this.reqNo});
				if(initres.ec == '0'){
					this.sdr_userId =  initres.reqInfo.sdr_userId;
					console.log(this.sdr_userId)
					this.deliveryModel = initres.reqInfo.sdr_delivery_model;
					this.areaId = JSON.parse(initres.reqInfo.sdr_dqmodel);
					this.shopName = initres.reqInfo.sdr_discount_shopName;
					this.shopAddr = initres.reqInfo.sdr_discount_shopAddr;
					this.proName = initres.reqInfo.sdr_discount_proName;
					this.proDesc = initres.reqInfo.sdr_discount_proDesc;
					this.proPrice = initres.reqInfo.sdr_discount_proPrice;
					this.discountStartDate = initres.reqInfo.sdr_discount_startDate;
					this.discountEndDate = initres.reqInfo.sdr_discount_endDate;
					this.isShowConcact = initres.reqInfo.sdr_isShowConcact == '1'?true:false;
					this.fileList = [];
					this.finalFileList = [];
					var attachlist = initres.reqInfo.attachlist;
					for(var index in attachlist){
						this.finalFileList.push({fileId:attachlist[index].sdra_fileid,path:attachlist[index].sdra_filePath,url:attachlist[index].sdra_filePath});
					}
					this.fileList = JSON.parse(JSON.stringify(this.finalFileList))
					this.searchLoading = false
					this.hasSearch = true
				}
			},
			async publish(){
				var vm = this;
				
				if(this.shopName.length == 0){
					this.$util.msg('请输入店面名称');
					return false;
				}
				if(this.shopAddr.length == 0){
					this.$util.msg('请输入店面地点');
					return false;
				}
				if(this.proName.length == 0){
					this.$util.msg('请输入商品名');
					return false;
				}
				if(this.areaId.length == 0){
					this.$util.msg('请选择面向地区');
					return false;
				}
				if(this.proDesc.length == 0){
					this.$util.msg('请输入商品描述');
					return false;
				}
				if(this.proPrice.length == 0){
					this.$util.msg('请输入价格');
					return false;
				}
				if(this.discountStartDate.length == 0){
					this.$util.msg('请输入折扣开始日期');
					return false;
				}
				if(this.discountEndDate.length == 0){
					this.$util.msg('请输入折扣结束日期');
					return false;
				}
				vm.$util.showMyLoading('加载中');
				var params = {};
				params.dqModel = JSON.stringify(this.areaId);
				params.fileList = JSON.stringify(this.finalFileList);
				params.reqNo = this.reqNo;
				params.reqType = "7";
				params.reqNail = this.$util.textFormat(this.reqNail);
				params.deliveryModel = this.deliveryModel;
				params.proName = this.proName;
				params.proDesc = this.proDesc;
				params.shopName = this.shopName;
				params.shopAddr = this.shopAddr;
				params.proPrice = this.proPrice;
				params.discountStartDate = this.discountStartDate;
				params.discountEndDate = this.discountEndDate;
				params.isShowConcact = this.isShowConcact ? '1' : '0';
				const initres = await postWithUInfo('/apis/modifyReqPost',params);
				if(initres.ec == '0'){
					vm.$util.hideMyLoading();
					this.$util.msg("修改成功",{},()=>{
						vm.goBack()
					});
				}
			},
			goChooseClassfiy(){
				this.$router.push({
				  name: 'publishIndex',
				  query: {}
				});
			},
			addOrMulitiFileList(params){
				// console.log(params)
				if(params.type == '1'){
					this.finalFileList.push({fileId:params.file.fileId,path:params.file.path,url:params.file.path,thumbPath:params.file.thumbPath})
					// console.log(this.fileList)
				}else if(params.type == '2'){
					this.finalFileList = this.finalFileList.filter((item,index) => {
						return item.fileId != params.file.fileId
					});
					// console.log(this.fileList)
				}
			},
			async queryCurrencySymbol(){
				const initres = await queryUrlWithUInfo('/apis/queryCurrencySymbol',{'dqModel':JSON.stringify(this.areaId)});
				if(initres.ec == '0'){
					this.CurrencySymbol = initres.currencySymbol;
				}
			},
			handleCityChange(e){
				// console.log(e)
				this.queryCurrencySymbol();
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.radio_warp {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		.radio_itm_warp {
			margin: 0px 10px 10px 0px;
		}
	}
	.container {
		width: 90%;
		margin: 0 auto;
		box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
		height: 100%;
		padding: 10px 20px;
		.headwarp {
			.head-item {
				width: 30%;
				text-align: left;
				line-height: 50px;
				border-bottom: 2px solid #F1F1F1;
			}
			.active {
				border-bottom: 2px solid #C88854;
			}
		}
		.cont-body {
			margin-top: 20px;
			//overflow: scroll;
			min-height: calc(100% - 100px);
			.content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				.ctx-item {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 10px 0;
					width: 600px;
					.bishu {
						color: #FF0000;
						margin-left: 4px;
					}
					.ctx-item-t {
						margin-right: 10px;
						.ctx-item-head {
							line-height: 40px;
							width: 160px;
							text-align: left;
							font-size: 14px;
							font-weight: 700;
						}
						.ctx-item-headdesc {
							font-size: 12px;
							text-align: left;
						}
					}
					.ctx-item-b {
						flex: 1;
						text-align:left;
					}
				}
			}
			.btn-foot {
				margin-top: 10px;
				.btn {
					width: 100px;
					margin: 0 auto;
					background-color: #c88854;
					color: #fff;
					padding: 10px 20px;
					border-radius: 30px;
					cursor: pointer;
				}
			}
		}
	}
</style>